import { TextField } from '@mui/material';

const AddressTextArea = ({ id, name, value, onChange, onBlur, error, ...props }) => {
  return (
    <TextField
      fullWidth
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      sx={{
        '& .MuiInputBase-root': {
          padding: '0',
        },

        '& .MuiInputBase-input': {
          fontSize: '1.25rem',
          padding: '10px',
          height: '40px',
          backgroundColor: '#F5F5F5',
          borderRadius: '8px',
        },

        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: error ? '#ED1C24' : '#F5F5F5',
        },
      }}
      {...props}
    />
  );
};

export default AddressTextArea;
